/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".flex-container[_ngcontent-%COMP%]{display:flex;justify-content:left;flex-wrap:wrap}"];
export { styles as styles };
